export const ManufactureIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="12 12 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.0007 24L23.0007 22"
        stroke="#8B8C93"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask0_16773_41985"
        maskUnits="userSpaceOnUse"
        x="12"
        y="12"
        width="24"
        height="24"
        {...{ "mask-type": "luminance" }}
      >
        <path
          d="M35.25 35.25V12.75H12.75V35.25H35.25Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
        />
      </mask>
      <g mask="url(#mask0_16773_41985)">
        <path
          d="M30.9146 26.0695L32.8185 19.2355C33.5554 16.5904 31.9889 13.8239 29.338 13.0886C26.6859 12.3533 23.9145 13.915 23.1762 16.5613L22.3264 19.6151M24.5182 33.1528C26.9306 33.4477 29.2797 31.9379 29.9494 29.5346L30.4923 27.5844"
          stroke="#8B8C93"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.4063 25.4471C19.8353 24.4258 16.9206 25.6774 15.897 28.2427C14.8734 30.8093 16.1279 33.7175 18.6988 34.7388C21.2698 35.7601 24.1846 34.5085 25.2082 31.9432C26.233 29.3767 24.9786 26.4696 22.4063 25.4471Z"
          stroke="#8B8C93"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6333 29.1245L24.7898 32.7617M25.4671 31.0684L16.3094 27.4299"
          stroke="#8B8C93"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3069 25.4077C23.0273 24.6509 23.47 23.627 23.47 22.4994C23.47 20.1657 21.5737 18.2737 19.2348 18.2737C18.1808 18.2737 17.2168 18.6584 16.4749 19.2951M15.4741 20.5555C15.1722 21.1377 15.001 21.7983 15.001 22.4994C15.001 24.146 15.9434 25.571 17.3209 26.2695"
          stroke="#8B8C93"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3157 22.0879H20.3064"
          stroke="#8B8C93"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.378 23.9111H19.3687"
          stroke="#8B8C93"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5788 22.5713H17.5681"
          stroke="#8B8C93"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.805 20.3984H18.7957"
          stroke="#8B8C93"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
